import { DriveItem } from '@cs-cms/types';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import ServicesContext from '../../contexts/ServicesContext';
import { msGraphKeys } from '../../queryKeys/msGraph';

export function useGetDriveItemFromUrl(
  fileUrl?: string,
  options?: { enabled?: boolean }
): UseQueryResult<DriveItem, unknown> {
  const servicesCtx = useContext(ServicesContext);

  const getDriveItem = () => {
    if (servicesCtx?.msGraphService && fileUrl) {
      return servicesCtx.msGraphService.getDriveItem(fileUrl);
    }
    throw new Error('Services context not initialized');
  };

  return useQuery({
    queryKey: msGraphKeys.getDriveItemFromUrl(fileUrl),
    queryFn: getDriveItem,
    retry: 0,
    staleTime: 180000,
    gcTime: 180000,
    enabled: options?.enabled ?? !!fileUrl
  });
}
